import * as UI from "@iyk/ui"
import { Assets } from "../../../shared/assets.ts"
import { COMPANY_NAME } from "../../../shared/constants.ts"
import { InfluencerRoutes } from "../../influencer-routes.ts"
import { Link } from "../../ui/link.tsx"

export const Header = ({ backTo }: MobileHeader.Props) => {
  return (
    <header className="relative flex items-center justify-center h-12">
      {backTo && (
        <Link
          to={InfluencerRoutes[backTo]}
          className={UI.classForButton({
            kind: "shaded",
            size: "sm",
            className: "absolute -translate-y-1/2 top-1/2 left-0",
          })}
        >
          <UI.Icon.ArrowLeft />
        </Link>
      )}
      <img src={Assets.images.logo} alt={COMPANY_NAME} className="object-cover h-8" />
    </header>
  )
}

namespace MobileHeader {
  export type Props = {
    backTo?: keyof typeof InfluencerRoutes
  }
}
